import React, { createContext, useContext, useState, useCallback } from 'react';
import { setToken, clearToken } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [merchant, setMerchant] = useState(null);
  const [token, setTokenState] = useState(null);

  const login = useCallback((tokenValue, merchantData) => {
    setTokenState(tokenValue);
    setToken(tokenValue);
    setMerchant(merchantData);
  }, []);

  const logout = useCallback(() => {
    setTokenState(null);
    clearToken();
    setMerchant(null);
  }, []);

  const updateMerchant = useCallback((data) => {
    setMerchant(prev => ({ ...prev, ...data }));
  }, []);

  const isAuthenticated = !!token;
  const hasCompletedOnboarding = merchant?.status !== 'pending_onboarding';

  return (
    <AuthContext.Provider value={{
      merchant,
      token,
      isAuthenticated,
      hasCompletedOnboarding,
      login,
      logout,
      updateMerchant,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
